import { buildGenericBrandLogoAlt } from 'helpers/seo'
import React, { FC, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { FadeIn } from '../Animations/Animations'

const TransparentLogo = styled('img')<{ maxHeight: number }>`
  margin: 0 auto;
  ${({ maxHeight }) =>
    css`
      max-height: ${maxHeight}%;
    `};
  ${FadeIn};
  animation-name: fadeIn;
  animation-timing-function: ease-in;
  animation-duration: 500ms;
`

const BrandLogo: FC<{ src?: string; alt?: string; dataTestId?: string }> = ({
  src,
  alt,
  dataTestId,
}) => {
  const [loading, setLoading] = useState(true)
  const [maxImageHeight, setMaxImageHeight] = useState(0)
  const genericAlt = buildGenericBrandLogoAlt(alt)

  useEffect(() => {
    if (typeof document === 'undefined' || !src) {
      return
    }
    let img: HTMLImageElement | null = document.createElement('img')
    img.src = src

    const onLoad = () => setHeight(img!)
    img.addEventListener('load', onLoad)
    return () => {
      img!.removeEventListener('load', onLoad)
      img = null
    }
  }, [src])

  const setHeight = (img: HTMLImageElement) => {
    let maxHeight: number
    const { width, height } = img
    const ratio = width / height

    if (ratio < 1) {
      maxHeight = 100
    }
    if (ratio > 4) {
      maxHeight = 25
    } else {
      maxHeight = 75 - ratio * (30 / 3)
    }

    setMaxImageHeight(maxHeight)
    setLoading(false)
  }

  return loading ? null : (
    <TransparentLogo
      maxHeight={maxImageHeight}
      data-testid={dataTestId && 'BrandLogo'}
      src={src}
      alt={genericAlt}
    />
  )
}

export default BrandLogo
